import React from "react";
import { TqpStatus } from "./PipeLineStatics/TqpStatus.js";
import PipeLineConversion from "./PipeLineStatics/PipeLineConversion.js";
import { PipeLineKpi } from "./PipeLineKpi";
import { LobWisePipeline } from "./PipeLineStatics/LobWisePipeline.js";
import FunnelChartDigram from "./PipeLineStatics/Funnel.js";

const PipeLine = () => {
  return (
    <div className="flex flex-col flex-grow">
      <div className="px-2 mt-2">
        <PipeLineKpi />
      </div>
      <div className="lg:flex gap-2 px-2 mb-2 md:block mt-2">
        <section className=" md:w-full">
          <div className="mb-2 bg-white rounded-md ">
            <FunnelChartDigram />
          </div>
          <div className="md:flex gap-2 block w-full">
            <section className=" bg-white rounded-md w-full">
              <TqpStatus />
            </section>
            <section className=" bg-white rounded-md w-full md:mt-0  mt-2">
              <PipeLineConversion />
            </section>
            <section className=" md:w-full mt-2 md:mt-0">
              <LobWisePipeline />
            </section>
          </div>
        </section>
      </div>
    </div>
  );
};

export default PipeLine;
